import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiPageHeaderComponent } from './fi-page-header.component';
import { ButtonBackModule } from '../../utilities/button-back/button-back.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';

@NgModule({
    declarations: [FiPageHeaderComponent],
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        ButtonBackModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        FiButtonBackNewModule,
    ],
    exports: [FiPageHeaderComponent],
})
export class FiPageHeaderModule {}
